import "../css/blockimage.css";
import { motion } from "framer-motion";

import line1 from "../img/line1.png";
import line2 from "../img/line2.png";

function BlockLeftImage(props) {
  return (
    <div className="relative-blockimage">
     <div className="wrapper-blockimage">
        <div>
          <motion.div
            className="rcontent"
            initial={{ opacity: 0, scale: 0.6 }}
            whileInView={{
              opacity: 1,
              scale: 1,
              transition: {
                type: "spring",
              },
            }}
          >
            <img src={props.src} alt={props.alt}></img>
          </motion.div>
        </div>

        <motion.div
          className="content padding"
          initial={{ y: 300, opacity: 0 }}
          whileInView={{
            y: 0,
            opacity: 1,
            transition: {
              type: "spring",
              stiffness: 200,
            },
          }}
        >
          {props.content}
        </motion.div>
      </div>

      <div className="bg-line1">
        <motion.div
          initial={{ scale: 0, opacity: 0 }}
          whileInView={{
            scale: 1,
            opacity: 1,
            transition: {
              type: "spring",
              damping: 50,
              duration: 10,
            },
          }}
        >
          <img className="line1" src={line1} alt="utpl"></img>
        </motion.div>
      </div>

      <div className="bg-line2">
        <motion.div
          initial={{ scale: 0, opacity: 0 }}
          whileInView={{
            scale: 1,
            opacity: 1,
            transition: {
              type: "spring",
              damping: 50,
              duration: 10,
            },
          }}
        >
          <img className="line2" src={line2} alt="utpl"></img>
        </motion.div>
      </div>

      <div className="bg-line3">
        <motion.div
          initial={{ scale: 0, opacity: 0 }}
          whileInView={{
            scale: 1,
            opacity: 1,
            transition: {
              type: "spring",
              damping: 50,
              duration: 10,
            },
          }}
        >
          <img className="line3" src={line2} alt="utpl"></img>
        </motion.div>
      </div>
    </div>
  );
}

export default BlockLeftImage;
